import { Modal } from "antd"



export default function AlertHandler(response: any) {
  const title = response?.name || response?.title||  response?.data?.title || response?.data?.name|| null
  const message = response.message || response?.data?.message  ||  null

  Modal.confirm({
    title: title ?  title : message ,
    content: title && title !== message? message : null,
    okCancel: false
  })

  return response
}
